<section class="agpr-monitoringResultSummary">
    @if (topic?.searchIntent && (mode === summaryModeEnum.topic || mode === summaryModeEnum.search)) {
        <agpr-panel
            header="Monitoring.search.topicPurpose"
        >
            <p>{{ topic.searchIntent }}</p>
        </agpr-panel>
    }

    @if (searchCriteria && (mode === summaryModeEnum.topic || mode === summaryModeEnum.search)) {
        <agpr-panel
            header="Monitoring.result.summary.searchQuery"
        >
            <div class="agpr-monitoringResultsSummary-searchCriteria">
                <div class="agpr-monitoringSearchCriteria">
                    <section class="agpr-monitoringSearchCriteria-keywordGroups">
                        @if (searchCriteria.query.expertBooleanQuery.filter) {
                            <div
                                class="agpr-definitionList ui-g"
                            >
                                <ng-container>
                                    <div
                                        class="agpr-definitionList-definitionTitle ui-g-12"
                                    >
                                       {{ 'Monitoring.searchCriteria.expertBoolean' | localize }}
                                    </div>
                                    <div
                                        class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                                    >
                                        <div
                                            class="agpr-keywordGroupSummary"
                                        >
                                            @if (searchCriteria.query.expertBooleanQuery.searchContexts.length > 0) {
                                                <div>
                                                    <ng-container *ngFor="let searchContext of searchCriteria.query.expertBooleanQuery.searchContexts; let last = last;">
                                                        <span class="agpr-keywordGroupSummary-keyword">
                                                            {{ searchContext.name | localize }}
                                                        </span>
                                                        @if (!last) { , }
                                                    </ng-container>
                                                </div>
                                            }
                                            <div>
                                                <ng-container>
                                                    <span class="agpr-keywordGroupSummary-keyword">
                                                        {{ searchCriteria.query.expertBooleanQuery.filter }}
                                                    </span>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        } @else {
                            <div
                                class="agpr-definitionList ui-g"
                            >
                                <ng-container *ngFor="let keywordGroup of searchCriteria.query.keywordGroups; let index = index;">
                                    @if (index !== 0) {
                                        <div
                                            class="agpr-definitionList-joiner ui-g ui-g-12 ui-g-nopad"
                                        >
                                            <div
                                                class="ui-g-nopad ui-g-6"
                                            >
                                                <div class="agpr-monitoringSearchCriteria-operator agpr-monitoringSearchCriteria-keywordGroupOperator">
                                                    {{ 'Monitoring.searchCriteria.and' | localize }}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div
                                        class="agpr-definitionList-definitionTitle ui-g-12"
                                    >
                                        {{ 'Monitoring.searchCriteria.keywordGroupX' | localize: { 'id': index + 1 } }}
                                    </div>
                                    <div
                                        class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                                    >
                                        <agpr-keyword-group-summary
                                            [keywordGroup]="keywordGroup"
                                        ></agpr-keyword-group-summary>
                                    </div>
                                </ng-container>
                            </div>
                        }
                    </section>
                    <section class="agpr-monitoringResultsSummary-bottomSummary">
                        <dl class="agpr-definitionList ui-g">
                            <dt
                                class="agpr-definitionList-definitionTitle ui-g-12"
                            >
                                {{ 'Monitoring.searchCriteria.mediaTypes' | localize }}
                            </dt>
                            <dd
                                class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                            >
                                <ng-container *ngFor="let mediaType of searchCriteria.query.includedMediaTypes; let last = last;">
                                    @if (mediaType.id === mediaTypes.TV && tvMediaTypeString) {
                                        {{ tvMediaTypeString }}
                                    } @else {
                                        {{ mediaType.name | localize }}
                                    }
                                    @if (!last) {
                                        <span class="agpr-monitoringSearchCriteria-operator">
                                            {{ 'Monitoring.searchCriteria.or' | localize }}
                                        </span>
                                    }
                                </ng-container>
                            </dd>

                            @if (searchCriteria?.isAccountSearch) {
                                <dt
                                    class="agpr-definitionList-definitionTitle ui-g-12"
                                >
                                    {{ 'Monitoring.searchCriteria.folders' | localize }}
                                </dt>
                                <dd
                                    class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                                >
                                    @if (folderIncludes?.length == 0 && folderExcludes?.length == 0) {
                                        <p>{{ 'all' | localize }}</p>
                                    }
                                    @if (folderIncludes.length > 0) {
                                        <p>
                                            {{ 'Monitoring.searchCriteria.include' | localize }}
                                            [
                                            <ng-container *ngFor="let source of folderIncludes; let last = last;">
                                                {{ source?.name }}
                                                @if (!last) {
                                                    <span class="agpr-monitoringSearchCriteria-operator">
                                                        {{ 'Monitoring.searchCriteria.or' | localize }}
                                                    </span>
                                                }
                                            </ng-container>
                                            ]
                                        </p>
                                    }
                                    @if (folderExcludes.length > 0) {
                                        <p>
                                            {{ 'Monitoring.searchCriteria.exclude' | localize }}
                                            [
                                            <ng-container *ngFor="let source of folderExcludes; let last = last;">
                                                {{ source?.name }}
                                                @if (!last) {
                                                    <span class="agpr-monitoringSearchCriteria-operator">
                                                        {{ 'Monitoring.searchCriteria.or' | localize }}
                                                    </span>
                                                }
                                            </ng-container>
                                            ]
                                        </p>
                                    }
                                </dd>
                                <dt
                                    class="agpr-definitionList-definitionTitle ui-g-12"
                                >
                                    {{ 'Monitoring.searchCriteria.tags' | localize }}
                                </dt>
                                <dd
                                    class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                                >
                                    @if (tagIncludes?.length == 0 && tagExcludes?.length == 0) {
                                        <p>{{ 'all' | localize }}</p>
                                    }
                                    @if (tagIncludes.length > 0) {
                                        <p>
                                            {{ 'Monitoring.searchCriteria.include' | localize }}
                                            [
                                            <ng-container *ngFor="let source of tagIncludes; let last = last;">
                                                {{ source?.name }}
                                                @if (!last) {
                                                    <span class="agpr-monitoringSearchCriteria-operator">
                                                        {{ 'Monitoring.searchCriteria.or' | localize }}
                                                    </span>
                                                }
                                            </ng-container>
                                            ]
                                        </p>
                                    }
                                    @if (tagExcludes.length > 0) {
                                        <p>
                                            {{ 'Monitoring.searchCriteria.exclude' | localize }}
                                            [
                                            <ng-container *ngFor="let source of tagExcludes; let last = last;">
                                                {{ source?.name }}
                                                @if (!last) {
                                                    <span class="agpr-monitoringSearchCriteria-operator">
                                                        {{ 'Monitoring.searchCriteria.or' | localize }}
                                                    </span>
                                                }
                                            </ng-container>
                                            ]
                                        </p>
                                    }
                                </dd>
                            }

                            <dt
                                class="agpr-definitionList-definitionTitle ui-g-12"
                            >
                                {{ 'Monitoring.searchCriteria.sources' | localize }}
                            </dt>
                            <dd
                                class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                            >
                                @if (searchCriteria.query.includedSources &&
                                    searchCriteria.query.includedSources.length == 0 &&
                                    searchCriteria.query.excludedSources &&
                                    searchCriteria.query.excludedSources.length == 0) {
                                    <p>{{ 'all' | localize }}</p>
                                }
                                @if (searchCriteria.query.includedSources && searchCriteria.query.includedSources.length > 0) {
                                    <p>
                                        {{ 'Monitoring.searchCriteria.include' | localize }}
                                        [
                                        <ng-container *ngFor="let source of searchCriteria.query.includedSources; let last = last;">
                                            {{ source.displayString }}
                                            @if (!last) {
                                                <span class="agpr-monitoringSearchCriteria-operator">
                                                    {{ 'Monitoring.searchCriteria.or' | localize }}
                                                </span>
                                            }
                                        </ng-container>
                                        ]
                                    </p>
                                }
                                @if (searchCriteria.query.excludedSources && searchCriteria.query.excludedSources.length > 0) {
                                    <p>
                                        {{ 'Monitoring.searchCriteria.exclude' | localize }}
                                        [
                                        <ng-container *ngFor="let source of searchCriteria.query.excludedSources; let last = last;">
                                            {{ source.displayString }}
                                            @if (!last) {
                                                <span class="agpr-monitoringSearchCriteria-operator">
                                                    {{ 'Monitoring.searchCriteria.or' | localize }}
                                                </span>
                                            }
                                        </ng-container>
                                        ]
                                    </p>
                                }
                            </dd>
                            <dt
                                class="agpr-definitionList-definitionTitle ui-g-12"
                            >
                                {{ 'Monitoring.searchCriteria.discoverList' | localize }}
                            </dt>
                            <dd
                                class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                            >
                                @if (discoverListDisplayString) {
                                    <span>{{ discoverListDisplayString }}</span>
                                }
                            </dd>
                            <dt
                                class="agpr-definitionList-definitionTitle ui-g-12"
                            >
                                {{ 'Monitoring.searchCriteria.regions' | localize }}
                            </dt>
                            <dd
                                class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                            >
                                @if (searchCriteria.query.includedRegions &&
                                    searchCriteria.query.includedRegions.length == 0 &&
                                    searchCriteria.query.excludedRegions &&
                                    searchCriteria.query.excludedRegions.length == 0) {
                                    <p>{{ 'all' | localize }}</p>
                                }
                                @if (searchCriteria.query.includedRegions && searchCriteria.query.includedRegions.length > 0) {
                                    <p>
                                        {{ 'Monitoring.searchCriteria.include' | localize }}
                                        [
                                        <ng-container *ngFor="let region of searchCriteria.query.includedRegions; let last = last;">
                                            {{ region.displayString }}
                                            @if (!last) {
                                                <span class="agpr-monitoringSearchCriteria-operator">
                                                    {{ 'Monitoring.searchCriteria.or' | localize }}
                                                </span>
                                            }
                                        </ng-container>
                                        ]
                                    </p>
                                }
                                @if (searchCriteria.query.excludedRegions && searchCriteria.query.excludedRegions.length > 0) {
                                    <p>
                                        {{ 'Monitoring.searchCriteria.exclude' | localize }}
                                        [
                                        <ng-container *ngFor="let region of searchCriteria.query.excludedRegions; let last = last;">
                                            {{ region.displayString }}
                                            @if (!last) {
                                                <span class="agpr-monitoringSearchCriteria-operator">
                                                    {{ 'Monitoring.searchCriteria.or' | localize }}
                                                </span>
                                            }
                                        </ng-container>
                                        ]
                                    </p>
                                }
                            </dd>
                            <dt
                                class="agpr-definitionList-definitionTitle ui-g-12"
                            >
                                {{ 'Monitoring.searchCriteria.languages' | localize }}
                            </dt>
                            <dd
                                class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                            >
                                @if (searchCriteria.query.includedLanguages &&
                                    searchCriteria.query.includedLanguages.length == 0 &&
                                    searchCriteria.query.excludedLanguages &&
                                    searchCriteria.query.excludedLanguages.length == 0) {
                                    <p>{{ 'all' | localize }}</p>
                                }
                                @if (searchCriteria.query.includedLanguages && searchCriteria.query.includedLanguages.length > 0) {
                                    <p>
                                        {{ 'Monitoring.searchCriteria.include' | localize }}
                                        [
                                        <ng-container *ngFor="let language of searchCriteria.query.includedLanguages; let last = last;">
                                            {{ language.name | localize }}
                                            @if (!last) {
                                                <span class="agpr-monitoringSearchCriteria-operator">
                                                    {{ 'Monitoring.searchCriteria.or' | localize }}
                                                </span>
                                            }
                                        </ng-container>
                                        ]
                                    </p>
                                }
                                @if (searchCriteria.query.excludedLanguages && searchCriteria.query.excludedLanguages.length > 0) {
                                    <p>
                                        {{ 'Monitoring.searchCriteria.exclude' | localize }}
                                        [
                                        <ng-container *ngFor="let language of searchCriteria.query.excludedLanguages; let last = last;">
                                            {{ language.name | localize }}
                                            @if (!last) {
                                                <span class="agpr-monitoringSearchCriteria-operator">
                                                    {{ 'Monitoring.searchCriteria.or' | localize }}
                                                </span>
                                            }
                                        </ng-container>
                                        ]
                                    </p>
                                }
                            </dd>
                            <dt
                                class="agpr-definitionList-definitionTitle ui-g-12"
                            >
                                {{ 'Monitoring.searchCriteria.sentiments' | localize }}
                            </dt>
                            <dd
                                class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                            >
                                <ng-container *ngFor="let sentiment of searchCriteria.query.sentiments; let last = last;">
                                    {{ sentiment.name | localize }}
                                    @if (!last) {
                                        <span class="agpr-monitoringSearchCriteria-operator">
                                            {{ 'Monitoring.searchCriteria.or' | localize }}
                                        </span>
                                    }
                                </ng-container>
                            </dd>
                            <dt
                                class="agpr-definitionList-definitionTitle ui-g-12"
                            >
                                {{ 'Monitoring.search.hideSimilar' | localize }}
                            </dt>
                            <dd
                                class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription ui-g-12"
                            >
                                @if (searchCriteria.showSimilar) {
                                    <span>{{ 'Monitoring.searchCriteria.false' | localize }}</span>
                                } @else {
                                    <span>{{ 'Monitoring.searchCriteria.true' | localize }}</span>
                                }
                            </dd>
                        </dl>
                    </section>
                </div>
            </div>
        </agpr-panel>
    }

    @if (mediaSubscription && mode === summaryModeEnum.subscription) {
        <agpr-panel
            header="Monitoring.result.summary.subscriptionQuery"
        >
            <div class="agpr-definitionList">
                @if (mediaSubscription.keywords.handles.length > 0) {
                    <div class="agpr-definitionList-definitionTitle">
                        {{ mediaHandles | localize }}
                    </div>
                    <div class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription">
                        <ng-container *ngFor="let handle of mediaSubscription.keywords.handles; let last = last;">
                            <span class="agpr-keywordGroupSummary-keyword">
                                {{ handle }}
                            </span>
                            @if (!last) {
                                <span class="agpr-keywordGroupSummary-operator">
                                    {{ 'KeywordGroupSummary.or' | localize }}
                                </span>
                            }
                        </ng-container>
                        &nbsp;
                    </div>
                }
                @if (mediaSubscription.keywords && mediaSubscription.keywords.hasAnyKeywords()) {
                    <div class="agpr-definitionList-definitionTitle">
                        {{ 'Monitoring.mediaSubscriptions.keywords' | localize }}
                    </div>
                    <div class="agpr-definitionList-definition agpr-monitoringSearchCriteria-filterDescription">
                        <agpr-keyword-group-summary
                            [keywordGroup]="mediaSubscription.keywords"
                            [styleClass]="null"
                        ></agpr-keyword-group-summary>
                    </div>
                }
            </div>
        </agpr-panel>
    }

    @if (attributes && attributesPanelHeading) {
        <agpr-panel
            [header]="attributesPanelHeading"
        >
            <agpr-attribute-list
                [attributes]="attributes"
            ></agpr-attribute-list>
        </agpr-panel>
    }

</section>
